import { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from "../../common/with-router";
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  Table,
  InputGroup,
} from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm } from "../../common/utils";
import Paginacao from "../../common/pagination";
import { format } from "date-fns"; // Para formatar datas

class TermosPlataformaAceites extends Component {
  constructor(props) {
    super(props);
    this.onChangeBusca = this.onChangeBusca.bind(this);
    this.onClickPagina = this.onClickPagina.bind(this);
    this.buscaRegistros = this.buscaRegistros.bind(this);

    this.state = {
      listRegistros: [],
      error: "",
      busca_user: "", // Filtro por usuário
      page_numb: 1,
      loading: true,
    };
  }

  componentDidMount() {
    this.consultaRegistro(this.state.busca_user, this.state.page_numb);
  }

  consultaRegistro(busca_user, page_numb = 1) {
    // URL CORRETA: /api/v1/termos-plataforma/consentimentos/
    api
      .get(
        `/termos-plataforma/consentimentos/?busca_user=${busca_user}&page=${page_numb}`
      )
      .then((response) => {
        this.setState({
          loading: false,
          error: "",
          listRegistros: response.data,
        });
      })
      .catch((error) => {
        let erro_msg = "Erro ao consultar aceites, tente novamente.";
        if (error.response && error.response.status === 403) {
          erro_msg = "Você não tem permissão para acessar essa área";
        }
        this.setState({
          loading: false,
          error: erro_msg,
        });
      });
  }

  renderRows = () => {
    if (
      "results" in this.state.listRegistros &&
      this.state.listRegistros.results.length > 0
    ) {
      return this.state.listRegistros.results.map((item) => (
        <tr key={item.id}>
          <td>
            {item.usuario_username} ({item.usuario_email})
          </td>
          <td>
            {item.termo_titulo} (v{item.termo_versao})
          </td>
          <td>
            {format(new Date(item.data_consentimento), "dd/MM/yyyy HH:mm:ss")}
          </td>
          <td>{item.ip_usuario}</td>
          <td>{item.user_agent}</td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan={5}>Nenhum registro de aceite encontrado.</td>
      </tr>
    );
  };

  onChangeBusca(e) {
    this.setState({
      busca_user: e.target.value,
    });
  }

  onClickPagina(num_page) {
    this.setState({
      loading: true,
      page_numb: num_page,
    });
    this.consultaRegistro(this.state.busca_user, num_page);
  }

  buscaRegistros(e) {
    e.preventDefault();
    this.setState({
      loading: true,
      page_numb: 1, // Reseta para a primeira página ao buscar
    });
    this.consultaRegistro(this.state.busca_user, 1);
  }

  render() {
    // Permissão de admin (gestor) para ver os logs
    if (!hasPerm("view_consentimentousuarioplataforma")) {
      return <Navigate to="/sem-permissao" />;
    }

    return (
      <div>
        <Row className="align-items-center">
          <Col sm={12} lg={12}>
            <h4 className="page-title">
              Logs de Aceite dos Termos da Plataforma
            </h4>
          </Col>
        </Row>
        <Card className="cardDestaque">
          <Card.Body>
            <Row>
              <Col sm={12} lg={12} className="mb-3">
                <Form method="get" onSubmit={this.buscaRegistros}>
                  <Form.Label>Buscar por Usuário</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="busca_user"
                      value={this.state.busca_user}
                      onChange={this.onChangeBusca}
                      placeholder="Buscar por nome, e-mail ou username..."
                    />
                    <Button type="submit" variant="light">
                      <FaSearch />
                    </Button>
                  </InputGroup>
                </Form>
              </Col>
            </Row>

            <Table responsive className="custom-table">
              <thead>
                <tr>
                  <th>Usuário (Email)</th>
                  <th>Termo (Versão)</th>
                  <th>Data do Aceite</th>
                  <th>IP</th>
                  <th>User Agent</th>
                </tr>
              </thead>
              <tbody>
                {this.state.loading ? (
                  <tr>
                    <td colSpan={5}>Carregando...</td>
                  </tr>
                ) : this.state.error ? (
                  <tr>
                    <td colSpan={5}>{this.state.error}</td>
                  </tr>
                ) : (
                  this.renderRows()
                )}
              </tbody>
            </Table>
            {"results" in this.state.listRegistros &&
              this.state.listRegistros.results.length > 0 && (
                <Paginacao
                  dados={this.state.listRegistros}
                  loading={this.state.loading}
                  page_numb={this.state.page_numb}
                  _onClickPagina={this.onClickPagina}
                />
              )}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default withRouter(TermosPlataformaAceites);
